import {
  AddNewDebtJournalEntriesRequest,
  SaveAccountingDatesRequest,
  UpdateDebtJournalEntryReviewStatusRequest,
} from '@/pages/DebtJournalEntries/types';
import { AxiosInstance } from 'axios';

export default class DebtAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getAllDebts() {
    return this.client.get('v2/debt/all-debts/');
  }

  async getDebtJournalEntries(payload: {
    debt_ids: number[];
    comp_entities: string[];
  }) {
    return this.client.post('v2/debt/journal-entries/', payload);
  }

  async saveDebtJournalEntries(payload: {
    je_rows: Array<{
      debt_id: number;
      row_status: 'new' | 'update' | 'delete';
      je_date: string;
      cash_balance: string | null;
      accrued_and_paid: string | null;
      accrued_not_paid: string | null;
      amortization: string | null;
      je_comment?: string;
      reviewer_id: string;
    }>;
  }) {
    return this.client.post('v2/debt/journal-entries/save/', payload);
  }

  async updateDebtJournalEntryReviewStatus(
    payload: UpdateDebtJournalEntryReviewStatusRequest,
  ) {
    return this.client.patch('v2/debt/journal-entries/review-status/', payload);
  }

  async addNewDebtJournalEntries(payload: AddNewDebtJournalEntriesRequest) {
    return this.client.post('v2/debt/journal-entries/add-new/', payload);
  }

  async getAccountingDates(compEntityId: string) {
    return this.client.get(`v2/accounting-dates/${compEntityId}/`);
  }

  async saveAccountingDates(payload: SaveAccountingDatesRequest) {
    return this.client.post('v2/accounting-dates/', payload);
  }
}
